import styles from './Button.module.css';

const Button = ({
  children,
  variant  = 'primary',
  size     = 'md',
  loading  = false,
  fullWidth= false,
  type     = 'button',
  disabled,
  onClick,
  ...rest
}) => (
  <button
    type={type}
    className={[
      styles.btn,
      styles[variant],
      styles[size],
      fullWidth ? styles.full : '',
    ].join(' ')}
    disabled={disabled || loading}
    onClick={onClick}
    {...rest}
  >
    {loading ? <span className={styles.spinner} /> : children}
  </button>
);

export default Button;
